<template>
    <div class="header-mini">
        <div class="header-bg" :style="{backgroundImage: `url(${img})`}"></div>
        <div class="header-curve" :style="{ backgroundImage : 'url(/static/img/headers/curve2.png)' }"></div>
        <div v-if="texts" class="header-footer">
          <div class="header-footer-left">
            <h1 v-if="texts[0]">{{texts[0]}}</h1>
            <h4 v-if="texts[1]">{{texts[1]}}</h4>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ["img", "texts"]
};
</script>

<style scoped>
.header-mini {
  height: 50vh;
  max-height: 50vh;
  min-height: 50vh;
  overflow: hidden;
  position: relative;
}
.header-bg {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  height: 100%;
  width: 100%;
  z-index: 1;
}
.header-curve {
  background-position: left;
  background-size: 100% 100%;
  bottom: 0;
  height: 250px;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 2;
}
.header-footer {
  align-items: center;
  bottom: 0;
  display: flex;
  height: 200px;
  justify-content: space-between;
  padding: 0 40px;
  position: absolute;
  width: 45%;
  z-index: 5;
}
.header-footer h1 {
  font-size: 34px;
  font-weight: 500;
  margin-bottom: 10px;
}
.header-footer h4 {
  font-size: 16px;
  line-height: 20px;
}
@media screen and (max-width: 1366px) {
  .header-curve {
    background-position: right;
  }
}
@media screen and (max-width: 1280px) {
  .header-curve {
    background-position: center;
  }
}
/* MOBILE */
@media screen and (max-width: 1000px) {
  .header-mini {
    height: 200px;
    max-height: initial;
    margin-bottom: 25px;
    min-height: initial;
    overflow: initial;
  }
  .header-curve {
    background-size: 100% 100%;
    height: 60px;
  }
  .header-footer {
    align-items: flex-end;
    bottom: -25px;
    height: 50px;
    padding: 0 30px;
    width: 100%;
  }
  .header-footer h1 {
    font-size: 20px;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/HeaderMini.vue